<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1200px"
      show-save-button
      unit="产成品退库单"
      edit-title
      id-key="commentId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
      @close="onClose"
    >
      <template slot="form">
        <!-- <el-button type="primary" icon="el-icon-plus" size="mini" style="margin:5px 0 10px 15px;" @click="addSa">选 单</el-button> -->
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <el-input
                v-model="data.DocNo"
                placeholder="请输入单据编号"
                v-if="noEdit"
              ></el-input>
              <span v-else>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                size="mini"
                v-model="data.DocDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="仓库" prop="WarehouseId">
              <el-select
                size="mini"
                v-model="data.WarehouseId"
                placeholder="请选择"
                @change="checkWare()"
                :disabled="isSelDisabled"
              >
              <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="销售单号" prop="OrderNo">
              <span>{{data.OrderNo}}</span>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="业务员" prop="ClerkName">
              <el-input v-model="data.ClerkName" @focus="addEmp" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input
                type="textarea"
                v-model="data.Remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" @onSelect="onSelect"/>
        </el-row>
      </template>
      <template slot="footer">
        <!-- <el-button size="mini" type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button size="mini" type="success" @click="examine" v-else-if="canExa">审 核</el-button> -->
      </template>
    </common-dialog>
    <sa-dialog ref="saDialog" in-dialog selectable @select="setSa" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogList from "./dialogList";
import saDialog from "@/components/sales/business/salesorder/saListDialog";
import empDialog from "@/components/sales/business/empDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    saDialog,
    empDialog
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocNo: "",
        DocDate: "",
        DocType: 1,
        Remark: "",
        OrderNo: "",
        OrderId: 0,
        WarehouseId: null,
        ClerkId: null,
        ClerkName: "",
        Status: 0,
        Goods:[]
      },
      noEdit: false,
      canExa: false,
      wareList: [],
      tableData: [],
      initTableData:[
        {
           T: 0,
          OrderGoodsId: 0,
          DocId: 0,
          BarCode: "",
          GoodsName: "",
          GoodsId:"",
          Model:"",
          UnitId: 0,
          UnitName:"",
          Quantity: 0,
          BatchNo:"",
          Offer:  0,
          Discount: 100,
          Price: 0,
          ExistQuantity:  0,
          AvailableQuantity:  0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost:  0,
          GrossProfit: 0,
          Remark: "",
          Thumbnail: "",
          OutQuantity: 0,
          AddTime: ""
        }
      ],
      PriAdjustSaList: [],
      api: require("@/api/sale/stInDoc").default,
      billApi: require("@/api/sy/bill").default,
      rules: {
        WarehouseId: [{ required: true, message: "仓库不能为空" }],
        // ClerkName: [{ required: true, message: "业务员不能为空" }],
      },
      isSelDisabled: false
    };
  },
  computed: {},
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    if(!this.data.DocDate) {
      this.data.DocDate = today
    }
  },
  methods: {
    onClose(){
      this.isSelDisabled = false
    },
    onSelect(){
      this.isSelDisabled = true
    },
    checkWare(){
      this.$refs.dialogList.tableData.forEach(e => {
        if(e.T!=0){
          e.T = 2
          this.$refs.dialogList.tableDel.push(e)
        }
      });
        this.$refs.dialogList.tableData = JSON.parse(JSON.stringify(this.initTableData))
        // this.$refs.dialogList.tableDel = []
    },
    addSa() {
      this.$refs.saDialog.open().then((that) => {
        that.getData();
      });
    },
    setSa(e) {
      
      this.data.OrderNo = e.OrderNo
      this.data.OrderId = e.OrderId
      this.$refs.dialogList.getData()
    },
    addEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    examine() {
      if(!this.data.WarehouseId){
        this.$message.error('请填写仓库')
        return
      }
      this.$confirm("确认审核数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("审核成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm("确认弃审数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.cancelExamine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("弃审成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened() {
      this.isSelDisabled = false
      this.canExa = false
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.tableDel = []
      var user = this.$store.state.user;
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.billApi.getDefaultSerialNo("产成品入库单").then(res => {
        if(res.Code==0&&res.Data) {
          this.data.DocNo = res.Data
        } else if(res.Code==0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
      this.$notify({
        title: '提示',
        message: '如果修改仓库会重置表格，需要重新编辑',
        duration: 5000
      });
    },
    onEditOpened(row) {
      this.isSelDisabled = true
      this.canExa = true
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.$notify({
        title: '提示',
        message: '如果修改仓库会重置表格，需要重新编辑',
        duration: 5000
      });
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      let tb = []
      if(tableData.length==0 || !tableData.some(v=>v.GoodsId)) {
        this.$message.error("请填写商品列表");
        return false;
      }
      for(var i = 0; i < tableData.length; i++) {
         if(tableData[i].GoodsId){
        if(!tableData[i].Quantity) {
          this.$message.error("请填写数量");
          return false;
        }
        if(tableData[i].T===0||tableData[i].T===1) {
          tb.push(tableData[i])
        }
         }
      }
      this.data.Goods = tb.concat(tableDel)
      
      return true
    },
  },
};
</script>